<template>
    <div>
        <bar-info ref=barInfo></bar-info>
        <cloud-note ref=cloudNote v-show="$route.query.isSelf!=2"></cloud-note>
    </div>
</template>
<script>
import BarInfo from './barInfo'
import CloudNote from './cloudNote'
export default {
    name: 'barCloud',
    components:{
        BarInfo,
        CloudNote
    },
    methods:{
        init(){
            this.$refs.barInfo.init()
            this.$refs.cloudNote.init()
        }
    }
}
</script>
